import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-forward",
  "use": "icon-nav-forward-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-nav-forward\"><path d=\"m9.6 4.6-.7.8 2.2 2.1H3v1h8.1l-2.2 2.1.7.8L13 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol